export default __webpack_public_path__ + "static/media/section1_1.4c642fe6.png";